var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInfo2 = function SvgIconInfo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.313a7.688 7.688 0 1 1 0 15.375A7.688 7.688 0 0 1 9 1.313Zm.012 1.67-.227.006A5.985 5.985 0 0 0 4.77 4.773a5.983 5.983 0 0 0-.036 8.492 5.978 5.978 0 0 0 8.494-.038 5.983 5.983 0 0 0 .036-8.492 5.978 5.978 0 0 0-4.026-1.748l-.227-.004ZM9 7.75c.582 0 1.054.472 1.054 1.054v3.433a1.054 1.054 0 1 1-2.108 0V8.804c0-.582.472-1.054 1.054-1.054Zm0-3.03a1.23 1.23 0 1 1 0 2.46 1.23 1.23 0 0 1 0-2.46Z",
    fill: "#04A985",
    fillRule: "evenodd"
  })));
};
export default SvgIconInfo2;